<template>
  <div id="cutom-main">
    <!-- Search Bar -->
    <!-- Main Container -->
    <div id="mainContainer" v-if="!loading">
      <header
        class="sticky-header"
        :class="{ 'header-addNewOtherContact': showAdd }"
      >
        <header-top />
        <header-bottom
          :specific-link="'OTHERS'"
          :heading="showAdd ? 'Add Contact' : 'Contacts'"
          :additional="{ showAdd, click: toggleAdd }"
          ref="headerBottom"
        />
        <add-new :hide-add="hideAdd" v-if="showAdd" />
      </header>
      <section-vue
        :showAdd="showAdd"
        :hideAdd="hideAdd"
        :sort-order="sortOrder"
        :toggle-sort-order="toggleSortOrder"
      />
    </div>
    <div class="loader-container" v-else>
      <loader-vue />
    </div>
  </div>
</template>

<script>
import AddNew from "./AddNew";
import HeaderTop from "../common/HeaderTop";
import HeaderBottom from "../common/HeaderBottom";
import SectionVue from "./Section";
import LoaderVue from "../Appointment/common/Loader.vue";
import { authMixin } from "../../mixins/authMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [authMixin],
  data() {
    return {
      sortOrder: true,
      showAdd: false
    };
  },
  components: {
    HeaderTop,
    HeaderBottom,
    SectionVue,
    LoaderVue,
    AddNew
  },
  computed: {
    ...mapGetters({
      loading: "getIsLoadingAddAppointment", // Should loading screen be shown
      selectedProviderID: "getSelectedProviderID" // The current selected provider id
    })
  },
  methods: {
    ...mapActions({
      getFormDetails: "getFormDetails" // Get form details from the server
    }),
    toggleSortOrder() {
      this.sortOrder = !this.sortOrder;
    },
    ...mapActions("clients", {
      getClientDetails: "getClientDetails" // Get the client details
    }),
    ...mapActions("chat", {
      getDetails: "getDetails" // Get the chat details
    }),
    ...mapActions("addNew", {
      getTimezones: "getTimezones" // Get the timezone details
    }),
    ...mapActions("person", {
      setToAddPersonMode: "setToAddPersonMode" // Search value in the search bar
    }),
    toggleAdd() {
      this.showAdd = !this.showAdd;
      this.setToAddPersonMode();
    },
    hideAdd() {
      this.showAdd = false;
    }
  },
  created() {
    this.getClientDetails();
    this.getDetails();
    this.getFormDetails();
    this.getTimezones();
  },
  watch: {
    selectedProviderID() {
      this.getClientDetails();
    }
  }
};
</script>

<style scoped>
.sticky-header {
  height: 97px;
}

#mainContainer {
  color: inherit;
  min-height: 100vh;
  height: auto !important;
  height: 100vh;
  margin: 41px auto -3em;
  overflow: hidden;
}

.calc-appoitment .header-icon-contain {
  padding: 2px 0px;
}

.calc-new-header {
  height: 18px;
  background-color: transparent;
}

/*header with radio buttons */

.header-addNewOtherContact {
  height: auto;
}

/* stage 2. Entered */
header >>> .drop-enter-active {
  animation: drop-down 0.2s ease-in-out forwards;
}

/* stage 3. leave */
header >>> .drop-leave-active {
  animation: lift-up 0.2s ease-in-out forwards;
}

@keyframes drop-down {
  from {
    transform: translateY(-5%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes lift-up {
  from {
    transform: translateY(0px);
    opacity: 1;
  }

  to {
    transform: translateY(-5%);
    opacity: 0;
  }
}
</style>
